"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameModule = void 0;
const injets_1 = require("injets");
const pixi_module_1 = require("./pixi/pixi.module");
const imager_module_1 = require("./imager/imager.module");
const room_module_1 = require("./room/room.module");
const loader_1 = require("../engine/loader");
const sound_module_1 = require("./sound/sound.module");
let GameModule = class GameModule {
};
__decorate([
    injets_1.Inject(),
    __metadata("design:type", loader_1.Loader)
], GameModule.prototype, "loader", void 0);
GameModule = __decorate([
    injets_1.Module({
        imports: [
            pixi_module_1.PixiModule,
            imager_module_1.ImagerModule,
            room_module_1.RoomModule,
            sound_module_1.SoundModule
        ],
    })
], GameModule);
exports.GameModule = GameModule;
